/** Indicador do realizado das metas */
export interface MetaIndicadorRealizado {
    id: number;
    nome: string;
    percInicial?: number;
    percFinal?: number;
    cor: string;
    badge: string;
}

/** Indicador realizado da meta baixo */
export const metaIndicadorRealizadoBaixo: MetaIndicadorRealizado = {
    id: 1,
    nome: 'Realizado Baixo',
    percFinal: 70,
    cor: '#f55e59',
    badge: 'badge badge-meta-indicador-realizado badge-meta-indicador-realizado-baixo'
};

/** Indicador realizado da meta médio */
export const metaIndicadorRealizadoMedio: MetaIndicadorRealizado = {
    id: 2,
    nome: 'Realizado Médio',
    percInicial: 70,
    percFinal: 90,
    cor: '#f7e55e',
    badge: 'badge badge-meta-indicador-realizado badge-meta-indicador-realizado-medio'
};

/** Indicador realizado da meta alto */
export const metaIndicadorRealizadoAlto: MetaIndicadorRealizado = {
    id: 3,
    nome: 'Realizado Alto',
    percInicial: 90,
    cor: '#20c764',
    badge: 'badge badge-meta-indicador-realizado badge-meta-indicador-realizado-alto'
};

/** Indicadores realizados das metas */
export const metasIndicadoresRealizados: MetaIndicadorRealizado[] = [
    metaIndicadorRealizadoBaixo,
    metaIndicadorRealizadoMedio,
    metaIndicadorRealizadoAlto
];

/** Verifica se o indicador do realizado da meta é baixo */
export function isMetaIndicadorRealizadoBaixo(percRealizado: number): boolean {
    if (percRealizado == null || percRealizado === undefined) {
        return false;
    }

    // <= 70%
    return percRealizado <= metaIndicadorRealizadoBaixo.percFinal;
}

/** Verifica se o indicador realizado da meta é médio */
export function isMetaIndicadorRealizadoMedio(percRealizado: number): boolean {
    if (percRealizado == null || percRealizado === undefined) {
        return false;
    }

    // > 70 && <= 90
    return percRealizado > metaIndicadorRealizadoMedio.percInicial && percRealizado <= metaIndicadorRealizadoMedio.percFinal;
}

/** Verifica se o indicador realizado da meta é alto */
export function isMetaIndicadorRealizadoAlto(percRealizado: number): boolean {
    if (percRealizado == null || percRealizado === undefined) {
        return false;
    }

    // > 90%
    return percRealizado > metaIndicadorRealizadoAlto.percInicial;
}


/** Obtem o indicador do realizado da meta através do percentual realizado */
export function getMetaIndicadorRealizado(percRealizado: number): MetaIndicadorRealizado {
    if (percRealizado != null && percRealizado !== undefined) {
        // Baixo
        if (isMetaIndicadorRealizadoBaixo(percRealizado)) {
            return metaIndicadorRealizadoBaixo;
        }
        // Médio
        if (isMetaIndicadorRealizadoMedio(percRealizado)) {
            return metaIndicadorRealizadoMedio;
        }
        // Alta
        if (isMetaIndicadorRealizadoAlto(percRealizado)) {
            return metaIndicadorRealizadoAlto;
        }
    }

    return null;
}

